import { render, staticRenderFns } from "./SaveStudyImage.vue?vue&type=template&id=8d422680&scoped=true&"
import script from "./SaveStudyImage.vue?vue&type=script&lang=js&"
export * from "./SaveStudyImage.vue?vue&type=script&lang=js&"
import style0 from "./SaveStudyImage.vue?vue&type=style&index=0&id=8d422680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d422680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d422680')) {
      api.createRecord('8d422680', component.options)
    } else {
      api.reload('8d422680', component.options)
    }
    module.hot.accept("./SaveStudyImage.vue?vue&type=template&id=8d422680&scoped=true&", function () {
      api.rerender('8d422680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/SaveStudyImage.vue"
export default component.exports